import { linkToPatient } from "$routes/patient/links";
import { stringify } from "qs";

export function linkToPatientInvestigationsNew({
  patientUuid,
}: {
  patientUuid?: string;
} = {}) {
  return `${linkToPatient()}/investigations/new${stringify(
    { patientUuid },
    { addQueryPrefix: true },
  )}`;
}
